import React from 'react';
import BannerHeader from "./components/BannerHeader";
import BannerAbout from './components/BannerAbout';
import Services from "./components/Services";
import Demo from './components/Demo';
// import Skills from './components/Skills';
import Team from './components/Team';
import Navbar from './components/Navbar'

import Footer from './components/Footer';

export const Home = () => (
  <div className="body_wrapper">
    <Navbar mainlogo="earth-logo.png" stickylogo="earth-logo.png"/>
    <BannerHeader/>
    <BannerAbout/>
    <Services/>
    <Demo/>
    {/* <Skills/> */}
    <Team/>
    <Footer/>
  </div>
)
